'use strict';

const Util = {
  toType (obj) {
    return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
  },
  formatDate (date) {
    if (date) {
      date = new Date(date);
      let day = date.getUTCDate();
      let month = date.getUTCMonth() + 1;
      return [(day < 10 ? '0' : '') + day, (month < 10 ? '0' : '') + month, date.getUTCFullYear()].join('/');
    }
    return date;
  }
};

export default {
  install: Vue => {
    Vue.prototype.$util = Util;
  }
};



// WEBPACK FOOTER //
// ./src/lib/util.js